<template>
  <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ affiliation.organisationID" aria-expanded="false" :aria-controls="'collapse-'+ affiliation.organisationID">
    <table class="" style="width: 100%">
      <tr :class="{selected: affiliation.selected}">
        <td class="col-md-5 col-xs-5 " style="" v-html="topDocument.title"></td>

        <td class="col-md-4 col-xs-4 " style="vertical-align: middle" >
          <div class="row is-table-row" style="width: 100%;">
            <div class="col-xs-5 col-md-5 text-center" style="vertical-align: middle">
              <flag v-if="affiliation && affiliation.organisationID" :squared="false" :iso="getIso(affiliation)" style="height: 100%"/>
            </div>
            <div class="col-md-7 col-xs-7 " v-if="affiliation && affiliation.organisationID" style="">{{affiliation.organisationName}}</div>

          </div>
        </td>
        <td class="col-md-1 col-xs-1 text-center" style="">{{affiliation.docs.length}}</td>
        <td class="col-md-1 col-xs-1 text-center" style="">{{topDocument.pubDate | moment('Y')}}</td>

        <td class="col-md-1 col-sm-1 text-center" style="vertical-align: center">
          <dropdown-affiliation v-model="affiliation" :document="topDocument" :context="context"></dropdown-affiliation>
        </td>
      </tr>
    </table>

    <div style="bottom: -9px;position: absolute;width: 100%">
      <span style="margin-left: 49%;background-color: white;">
        <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
        <i class="fa fa-chevron-down"></i>
        </button>
      </span>
    </div>
  </div>
</template>

<style scoped>

  .is-table-row {
    display: table;
  }
  .is-table-row [class*="col-"] {
    float: none;
    display: table-cell;
    vertical-align: top;
  }

  .selected {
    border-left: 5px solid #ffb606;
  }

  .dropdown-menu {
    min-width: 50px;
  }
  div > .dropdown > i {
    cursor: pointer;
  }

  .dropdown-expert-action > ul > li i{
    font-weight: bold;
    margin-right: 5px;
  }

  .dropdown-expert-action ul > li a{
    font-size: 12px;
  }

  .dropdown-expert-action ul > li{
    margin-bottom: 5px;
    font-size: 12px;
  }

  .top-document {
    cursor: pointer;
    /*max-height: 80px;*/
    padding: 15px 0;
    border-bottom: 1px solid #eaeaea;
  }
  .top-document:hover {
    background: #f5f5f5;
  }

</style>
<script>
import 'jquery-bar-rating/dist/jquery.barrating.min'
import IsoCountries from 'i18n-iso-countries'
import EnCountries from '../../iconFlag/en'
import DropdownAffiliation from './DropdownAffiliation'

IsoCountries.registerLocale(EnCountries)

export default {
  components: {DropdownAffiliation},
  name: 'AffiliationTop',
  props: ['value', 'pubDateSelected', 'context'],
  data () {
    return {
      affiliation: null,
      topDocument: null
    }
  },
  watch: {
    value: function (val) {
      this.affiliation = val
    },
    affiliation: function (val, oldVal) {
      if (oldVal !== null) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getIso: (affiliation) => {
      if (typeof affiliation !== 'undefined') {
        let iso = IsoCountries.getAlpha2Code(affiliation.country, 'en')
        if (typeof iso === 'undefined') {
          iso = IsoCountries.toAlpha2(affiliation.code)
        }
        return iso
      }
    }
  },
  updated () {
    this.topDocument = this.affiliation.docs[0]
  },
  beforeMount () {
    this.affiliation = this.value

    this.affiliation.docs.sort(function (doc1, doc2) {
      return new Date(doc2.pubDate) - new Date(doc1.pubDate)
    })

    this.topDocument = this.affiliation.docs[0]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/AffiliationTop.vue